import { ChartSection, PieChartContainer, TotalCountContainer } from './styled';
import { CountBoxLoadingIcon } from './CountBoxLoadingIcon';
import { ChartLoadingIcon } from './ChartLoadingIcon';

export const ChartLoader = () => {
  return (
    <ChartSection data-test="chart-loading-state">
      <TotalCountContainer>
        <CountBoxLoadingIcon />
      </TotalCountContainer>

      <PieChartContainer>
        <ChartLoadingIcon />
      </PieChartContainer>
    </ChartSection>
  );
};
